export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#0A1628] border-t border-white/8 py-16 px-6 lg:px-10">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-8">
        <div>
          <p className="font-black text-2xl tracking-tighter text-[#FAFAF7] mb-1">Althera Group</p>
          <p className="text-sm text-[#FAFAF7]/40 font-medium">Retention as a service</p>
        </div>

        <div className="flex flex-col sm:items-end gap-1">
          <p className="text-xs text-[#FAFAF7]/25">
            &copy; 2026 Althera Group. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
